import { parse as parseCookieHeaderWithOptions, serialize as serializeSetCookieHeader, } from "cookie";
import { toBase64Url } from "@cerbos/spitfire-shared/base64url";
import { fromUtf8 } from "./bytes.js";
import { identity } from "./identity.js";
import { stringify as stringifyJson } from "./json.js";
import { base64UrlSchema, jsonStringSchema, utf8Schema } from "./schema.js";
export class Cookie {
    name;
    schema;
    serializeOptions;
    constructor(name, schema, attributes) {
        this.name = `__Host-${name}`;
        this.schema = base64UrlSchema
            .pipe(utf8Schema)
            .pipe(jsonStringSchema)
            .pipe(schema);
        this.serializeOptions = {
            encode: identity,
            path: "/",
            priority: "medium",
            sameSite: "lax",
            secure: true,
            ...attributes,
        };
    }
    read({ headers }) {
        return this.parse(parseCookieHeader(headers.get("Cookie")));
    }
    parse(cookies) {
        const value = cookies[this.name];
        if (!value) {
            return null;
        }
        return this.decode(value);
    }
    decode(value) {
        const result = this.schema.safeParse(value);
        return result.success ? result.data : null;
    }
    write(data) {
        return ["Set-Cookie", this.serialize(data)];
    }
    destroy() {
        return ["Set-Cookie", this.serialize(null)];
    }
    serialize(data) {
        const value = this.encode(data);
        const options = value
            ? this.serializeOptions
            : { ...this.serializeOptions, maxAge: 0 };
        return serializeSetCookieHeader(this.name, value, options);
    }
    encode(data) {
        if (data === null) {
            return "";
        }
        return toBase64Url(fromUtf8(stringifyJson(data)));
    }
}
export function parseCookieHeader(cookieHeader) {
    if (!cookieHeader) {
        return {};
    }
    return parseCookieHeaderWithOptions(cookieHeader, { decode: identity });
}
/**
 * A cookie that is not signed or encrypted.
 * It can be read and written both in the browser and on the server.
 * It should only be used for persisting a user's per-device preferences.
 */
export class UnsignedCookie extends Cookie {
    constructor(name, schema, options = {}) {
        super(name, schema, {
            httpOnly: false,
            ...options,
        });
    }
}
//# sourceMappingURL=cookie.js.map